import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import { Observable } from 'rxjs';
import {SkpdModel} from "./skpd.model";

@Injectable({
  providedIn: 'root'
})
export class SkpdRequiredGuard implements CanActivate {

  constructor(private _router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let skpd:SkpdModel = JSON.parse(localStorage.getItem('skpdDetail'))
    let defaultYear = localStorage.getItem('defaultYear');
    if (skpd.id != -1){
      return true;
    } else {
      this._router.navigate([`/${defaultYear}/skpd`]);
      return false;
    }
  }

}
